import { render, staticRenderFns } from "./LocalizedQuestion.vue?vue&type=template&id=24c59006&"
import script from "./LocalizedQuestion.vue?vue&type=script&lang=js&"
export * from "./LocalizedQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports